<template>
    <div id="AssetFeatureCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                        <span class="page-title" id="assetFeatureHeader" v-if="$route.params.id > 0">Update Asset Standard Feature</span>
                        <span class="page-title" id="assetFeatureHeader" v-else>Add Asset Standard Feature</span>
                        <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackAssetFeatureList" >
                               <i class="fp-back"> </i> Back
                        </button>
                    </div>
                <div class="container-fluid">
                    <div class="admin-page-content standard-feature-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container add-user-form-title form-custom-select" id="AssetFeatureForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="vehicle">Asset:</label>            
                                        <v-select v-model="vehicle" name="vehicle"
                                                    id="vehicle-select"
                                                    label="text" :filterable="false" :options="vehicleArr"
                                                    @search="onSearchAsset"
                                                    placeholder="Select Asset" class="custom-ci-auto-search">
                                        <template slot="no-options">
                                            Search Asset...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{vehicle_error_msg}}</div>        
                                    </div>
                                    <template v-for="(category,key) in assetFeatureCategoryAll">
                                        <div :key="key" class="col form-group">
                                            <label class="control-label"> {{category.category_name}}</label>
                                                <v-select
                                                class="multiselect"
                                                v-model="categoryFeatures[category.id]"
                                                :options="category.category_features"
                                                :close-on-select="true"
                                                :show-labels="true"
                                                :multiple="true"
                                                :searchable="true"
                                                track-by="id"
                                                label="feature_name"
                                                placeholder="Select Feature."
                                                >
                                                </v-select>
                                        </div>
                                    </template>
                                    <template v-if="assetFeatureCategoryAll.length == 0">
                                        <div class="col form-group">
                                            <span>There is no feature added yet. <router-link v-bind:to="{ path:'/feature/create'}" href="/feature/create">
                                                Click here
                                                </router-link> to add features.
                                            </span>
                                        </div>
                                    </template>
                                    <div class="field-error">{{ common_error_msg }}</div>
                                </div>  
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateAssetFeatureBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateAssetFeature" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="CreateAssetFeatureBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateAssetFeature" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueAssetFeatureBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateAssetFeature(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelAssetFeatureBtn" class="btn btn-tertiary" v-on:click.prevent="BackAssetFeatureList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';

 



export default {
  name: "AssetFeatureCreate",
  metaInfo() {
    return {
        title: (this.$route.params.id > 0)? "Update Asset Standard Feature | " +process.env.COPYRIGHT_NAME : "Create Asset Standard Feature | " +process.env.COPYRIGHT_NAME
    }
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    assetFeatureCategoryAll:[],
    assetFeatures:[],
    vehicle: null,
    vehicleArr: [],
    vehicle_error_msg: "",
    code: "",
    category:{
        vehicle_id:'',
        category_features:[]
    },
    categoryFeatures:[],
    name:"",
    weight_front:"",
    weight_rear:"",
    arr: [],
    common_error_msg:"",
    blockRemoval: true,
    loading:false,
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_feature') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },

        //load features of category on the basis of vehicle_id
        vehicle: function(vehicle) {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            
            if(self.vehicle == null || self.vehicle === ""){
                return;
            }
            if(!segments[3]){
                console.log(vehicle.value);
                self.loading = true;
                $.ajax({
                url: process.env.ROOT_API + "/assetfeature/search",
                type: "POST",
                headers: this.ajxHeaders,
                crossDomain: true,
                dataType:"json",
                data:{
                    vehicle_id:vehicle.value,
                },
                success: function (data) {
                    // console.log(data);
                    self.loading = false;
                    self.categoryFeatures = [];
                    if(data.content.length > 0){
                        for(var i=0;i<data.content.length;i++){
                            var catId = data.content[i].id;
                            self.categoryFeatures[catId] = data.content[i].category_features;
                            // console.log(data.content[i].id);
                            // console.log(self.categoryFeatures[catId]);
                        }
                    }
                    
                },
                error: function (jqXHR, exception) {
                    self.Registerbtn = "Register";
                    self.generateStatusCodeMessage(jqXHR, true, 'asset-std-feature-search')
                }
            });
            }
        },

   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.AssetFeatureCategoryAll();

        var path = window.location.pathname;
        var segments = path.split("/");
        if (segments[3]) {
            self.loadAssetFeature();
            
        }
        
  },
  methods: {
    changeChanged(){
        var self = this;
        console.log(self.category.category_features);
    },
    onSearchAsset(search, loading) {
        var self = this;
        if (search.length > 3) {

            loading(true);
            self.searchField(loading, search, 'vehicle', '');
        }
    },
    AssetFeatureCategoryAll(){

        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/assetfeaturecategory/search",
            type: "POST",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType: "json",
            success: function (data) {
                console.log(data);
                if (data.status == "success") {
                    self.assetFeatureCategoryAll = data.content;
                }

            },
            error: function (jqXHR, exception) {
                self.generateStatusCodeMessage(jqXHR, true, 'asset-std-feature-caregory-search')
            }
        });

    },

    BackAssetFeatureList() {
      var self = this;
      self.$router.push("/assetfeature/list");
    },

    CreateAssetFeature(flag) {
      var self = this;
      var error = false;

      self.vehicle_error_msg = "";
      self.common_error_msg = "";
     
      if (self.vehicle == null || !self.vehicle.value) {
        self.vehicle_error_msg = "Asset Required.";
        error = true;
      }
      
      if(self.categoryFeatures.length < 1){
        self.common_error_msg = "Please Select Feature."
        error = true;
      }

      var featuresArray = []; /*featuresArray with selected feature id */
      for(var i=0;i<self.categoryFeatures.length;i++){
        if( self.categoryFeatures[i] != undefined){
            for(var j=0;j<self.categoryFeatures[i].length;j++){
                if(self.categoryFeatures[i].length > 0){
                    featuresArray.push(self.categoryFeatures[i][j].id); 
                }
            }  
        }   
      }
      
      /*if any feature is not selected */
      if(featuresArray.length < 1){
            self.common_error_msg = "Please Select Feature."
            error = true;
      }
     
      if (!error) {
              
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateAssetFeatureBtn").val("Updating ...");
                $("#CreateAssetFeatureBtn").prop("disabled", true);
                $("#cancelAssetFeatureBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueAssetFeatureBtn").val("Saving ...");
                    $("#CreateAssetFeatureBtn").prop("disabled", true);
                    $("#createAndContinueAssetFeatureBtn").prop("disabled", true);
                    $("#cancelAssetFeatureBtn").prop("disabled",true);

                }else{

                    $("#CreateAssetFeatureBtn").val("Saving ...");
                    $("#CreateAssetFeatureBtn").prop("disabled", true);
                    $("#createAndContinueAssetFeatureBtn").prop("disabled", true);
                    $("#cancelAssetFeatureBtn").prop("disabled",true);
                }
               
            }


            var fields = $("#AssetFeatureForm").serializeArray();
            fields.push({name: "vehicle_id", value: self.vehicle.value});
            fields.push({name: "id", value: segments[3]});
            fields.push({name:"features",value: JSON.stringify(self.categoryFeatures)});
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/assetfeature/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateAssetFeatureBtn").val("Update");
                        $("#CreateAssetFeatureBtn").prop("disabled", false);
                        $("#cancelAssetFeatureBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueAssetFeatureBtn").val("Save and Continue");
                            $("#CreateAssetFeatureBtn").prop("disabled", false);
                            $("#createAndContinueAssetFeatureBtn").prop("disabled", false);
                            $("#cancelAssetFeatureBtn").prop("disabled",false);

                        }else{

                            $("#CreateAssetFeatureBtn").val("Save");
                            $("#CreateAssetFeatureBtn").prop("disabled", false);
                            $("#createAndContinueAssetFeatureBtn").prop("disabled", false);
                            $("#cancelAssetFeatureBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#AssetFeatureForm").trigger("reset");
                            self.vehicle = null;
                            self.categoryFeatures = [];
                    
                        }else{  
                            self.$router.push("/assetfeature/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            // if (data.message == "limit_validation") {
                            //     // err += data.content;
                            //     for (var i = 0; i < data.content.length; i++) {
                            //         err += data.content[i] + "<br>";
                            //     }
                            // } else {
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i] + "<br>";
                                }
                            // }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateAssetFeatureBtn").val("Update");
                        $("#CreateAssetFeatureBtn").prop("disabled", false);
                        $("#cancelAssetFeatureBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#AssetFeatureForm").trigger("reset");
                            

                            $("#createAndContinueAssetFeatureBtn").val("Save and Continue");
                            $("#CreateAssetFeatureBtn").prop("disabled", false);
                            $("#createAndContinueAssetFeatureBtn").prop("disabled", false);
                            $("#cancelAssetFeatureBtn").prop("disabled",false);

                        }else{

                            $("#CreateAssetFeatureBtn").val("Save");
                            $("#CreateAssetFeatureBtn").prop("disabled", false);
                            $("#createAndContinueAssetFeatureBtn").prop("disabled", false);
                            $("#cancelAssetFeatureBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR, true, 'asset-std-feature-create')
                }
            });
        }else{
            self.errorValidationFocus();
        }
     
    },

    loadAssetFeature() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/assetfeature/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;

                if (data.status == "success") {
                    
                    // self.vehicle = {value: data.content.vehicle_id, text: self.titleCase(data.content.vName) + " (" + self.titleCase(data.content.vUnitNo) + ") (" + self.titleCase(data.content.vtCode) + ")"};
                    if(data.content.vehicle_id != null){
                        var vehicleData = self.titleCase(data.content.vUnitNo);
                        if(data.content.vtCode != null){
                            vehicleData += " | " + self.titleCase(data.content.vtCode);
                        }
                        if(data.content.vName != null){
                            vehicleData += " | " + self.titleCase(data.content.vName);
                        }
                        self.vehicle = {value: data.content.vehicle_id, text: vehicleData};
                    }else{
                        self.vehicle = null;
                    }
                    $("#vehicle-select").addClass("js-example-disabled");
                    self.categoryFeatures = [];
                    if(data.content.featureArray.length > 0){
                        for(var i=0;i<data.content.featureArray.length;i++){
                            var catId = data.content.featureArray[i].id;
                            self.categoryFeatures[catId] = data.content.featureArray[i].category_features;
                        }
                    }
                    
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR, false, 'asset-std-feature-load')
            }
        });
    },

    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },

    formatString(data) {

        if (data == null){
        }else{
            var self = this;
            var value = data.replace(/_/g, " ");
            var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                return letter.toUpperCase();
            });
            return upp;
        }
    },
  }
};
</script>
<style scoped>
/* disable v-select of Asset on Edit*/
.js-example-disabled {
    pointer-events:none;
    color: #bfcbd9;
    cursor: not-allowed;
    background-image: none;
    background-color: #eef1f6;
    border-color: #d1dbe5;
}
</style>



// WEBPACK FOOTER //
// src/components/AssetFeatureCreate.vue